(() => {
  let sequence = 0;
  const initialized = new WeakSet();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const info = root.querySelector('.product__info-container');
    if (!info) return;
    const cards = () => Array.from(info.querySelectorAll('.sg-inline-colour'));
    const copy = root.dataset;
    const choiceSelector = 'input[type="radio"], input[type="checkbox"]';
    let openId = null;
    let hadErrors = false;
    let restoring = false;
    const selections = new Map();
    function setOpen(card, open, restoreFocus = false) {
      const button = card.querySelector('.sg-colour-toggle');
      const palette = card.querySelector('.gpo-ov-wrapper');
      const hint = card.querySelector('.sg-colour-hint');
      const done = card.querySelector('.sg-colour-done');
      if (!button || !palette) return;
      if (open) openId = card.dataset.elementId;
      else if (openId === card.dataset.elementId) openId = null;
      if (open) cards().forEach(other => { if (other !== card) setOpen(other, false); });
      button.setAttribute('aria-expanded', String(open));
      palette.hidden = !open;
      if (hint) hint.hidden = !open;
      if (done) done.hidden = !open;
      if (restoreFocus) button.focus({ preventScroll: true });
    }
    function update(card) {
      const chosen = Array.from(card.querySelectorAll(choiceSelector)).filter(input => input.checked);
      const text = card.querySelector('.sg-colour-value');
      const chip = card.querySelector('.sg-colour-chip');
      if (!text || !chip) return;
      const name = chosen.length ? chosen.map(input => input.value).join(', ') : copy.colourChoose;
      selections.set(card.dataset.elementId, chosen.map(input => input.value));
      const limit = Number(card.dataset.sgColourLimit);
      if (limit) card.querySelectorAll('input[type="checkbox"]').forEach(input => {
        if (!input.checked && chosen.length >= limit) {
          if (!input.disabled) {
            input.dataset.sgLimitDisabled = 'true';
            input.disabled = true;
          }
        } else if (input.dataset.sgLimitDisabled === 'true') {
          input.disabled = false;
          delete input.dataset.sgLimitDisabled;
        }
      });
      if (text.textContent !== name) text.textContent = name;
      chip.hidden = !chosen.length;
      if (chosen.length) {
        const colours = chosen.map(input => input.dataset.color1 || '#777777');
        const fill = colours.length === 1 ? colours[0] : `linear-gradient(90deg, ${colours.map((colour, index) => `${colour} ${index * 100 / colours.length}% ${(index + 1) * 100 / colours.length}%`).join(', ')})`;
        chip.style.setProperty('--sg-selected-colour', fill);
      }
    }
    function enhance() {
      info.querySelectorAll('.gpo-element[data-element-id^="color-swatches"]').forEach(card => {
        const palette = card.querySelector('.gpo-ov-wrapper');
        const label = card.querySelector('.gpo-label .label-content');
        if (!palette || !label || !palette.querySelector(choiceSelector)) return;
        const multiple = !!palette.querySelector('input[type="checkbox"]');
        const help = multiple ? card.querySelector('.gpo-helptext')?.textContent.trim() || copy.colourHelp : copy.colourHelp;
        if (!card.querySelector('.sg-colour-toggle')) {
          card.classList.add('sg-inline-colour');
          const limit = multiple && help.match(/up to\s+(\d+)/i);
          if (limit) card.dataset.sgColourLimit = limit[1];
          card.removeAttribute('style');
          card.querySelectorAll('.gpo-label, .label-content, .gpo-helptext, .gpo-ov-wrapper, .gpo-swatches.color-swatches, .gpo-swatches.color-swatches label, .gpo-swatch__inner').forEach(node => node.removeAttribute('style'));
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sg-colour-toggle';
          const part = document.createElement('span');
          part.className = 'sg-colour-part';
          part.textContent = label.textContent.trim();
          const selection = document.createElement('span');
          selection.className = 'sg-colour-selection';
          const chip = document.createElement('span');
          chip.className = 'sg-colour-chip';
          chip.setAttribute('aria-hidden', 'true');
          const value = document.createElement('span');
          value.className = 'sg-colour-value';
          value.setAttribute('aria-live', 'polite');
          const arrow = document.createElement('span');
          arrow.className = 'sg-colour-arrow';
          arrow.textContent = '⌄';
          arrow.setAttribute('aria-hidden', 'true');
          selection.append(chip, value, arrow);
          button.append(part, selection);
          palette.id ||= `sg-colour-palette-${++sequence}`;
          button.id = `${palette.id}-toggle`;
          button.setAttribute('aria-controls', palette.id);
          palette.setAttribute('role', multiple ? 'group' : 'radiogroup');
          palette.setAttribute('aria-label', part.textContent);
          const hint = document.createElement('p');
          hint.className = 'sg-colour-hint';
          hint.textContent = help;
          card.prepend(button);
          palette.after(hint);
          if (multiple) {
            const done = document.createElement('button');
            done.type = 'button';
            done.className = 'sg-colour-done';
            done.textContent = copy.colourDone;
            hint.after(done);
            done.addEventListener('click', () => setOpen(card, false, true));
          }
          palette.querySelectorAll(choiceSelector).forEach(input => {
            input.setAttribute('aria-label', input.value);
            const swatch = input.closest('.gpo-swatches');
            if (swatch) swatch.setAttribute('title', input.value);
          });
          button.addEventListener('click', () => setOpen(card, button.getAttribute('aria-expanded') !== 'true'));
          let keyboardNavigation = false;
          card.addEventListener('pointerdown', () => { keyboardNavigation = false; });
          card.addEventListener('change', event => {
            if (!event.target.matches(choiceSelector)) return;
            update(card);
            const selected = Array.from(card.querySelectorAll(choiceSelector)).filter(input => input.checked).map(input => input.value);
            hint.textContent = selected.length ? `${help} ${copy.colourSelected}: ${selected.join(', ')}` : help;
            if (restoring || multiple) return;
            if (keyboardNavigation) { keyboardNavigation = false; return; }
            setOpen(card, false, true);
          });
          card.addEventListener('keydown', event => {
            if (event.target.matches(choiceSelector)) {
              if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) keyboardNavigation = true;
              if (event.key === 'Enter' && (multiple || event.target.checked)) {
                event.preventDefault();
                setOpen(card, false, true);
              }
            }
            if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
              event.preventDefault();
              setOpen(card, false, true);
            }
          });
          const showName = event => {
            const swatch = event.target.closest('.gpo-swatches');
            const input = swatch && swatch.querySelector(choiceSelector);
            if (input) hint.textContent = input.value;
          };
          palette.addEventListener('pointerover', showName);
          palette.addEventListener('focusin', showName);
          palette.addEventListener('pointerleave', () => {
            const chosen = Array.from(card.querySelectorAll(choiceSelector)).filter(input => input.checked).map(input => input.value);
            hint.textContent = chosen.length ? `${help} ${copy.colourSelected}: ${chosen.join(', ')}` : help;
          });
          setOpen(card, openId === card.dataset.elementId);
        }
        const previous = selections.get(card.dataset.elementId);
        if (previous?.length && !card.querySelector('input:checked')) {
          restoring = true;
          Array.from(card.querySelectorAll(choiceSelector)).filter(option => previous.includes(option.value) && !option.disabled).forEach(input => input.click());
          restoring = false;
        }
        update(card);
      });
      const rows = cards();
      if (rows.length) {
        rows.forEach((row, index) => {
          row.classList.toggle('sg-colour-first', index === 0);
          row.classList.toggle('sg-colour-last', index === rows.length - 1);
        });
        if (!info.querySelector('.sg-colour-heading')) {
          const heading = document.createElement('h2');
          heading.className = 'sg-colour-heading';
          heading.textContent = copy.colourHeading;
          rows[0].before(heading);
        }
        const invalid = rows.filter(row => row.querySelector('.messages')?.textContent.trim() && !row.querySelector('input:checked'));
        if (!hadErrors && invalid.length) setOpen(invalid[0], true);
        hadErrors = invalid.length > 0;
      }
    }
    info.addEventListener('invalid', event => {
      const card = event.target.closest('.sg-inline-colour');
      if (card) setOpen(card, true);
    }, true);
    window.addEventListener('click', event => {
      if (!root.isConnected || !root.contains(event.target)) return;
      if (!event.target.closest('button[name="add"]')) return;
      const missing = cards().find(card => card.querySelector('.gpo-label.required') && !card.querySelector('input:checked'));
      if (missing) setOpen(missing, true);
    }, true);
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; enhance(); });
    });
    observer.observe(info, { childList: true, subtree: true });
    enhance();
  }
  const start = () => document.querySelectorAll('[data-sg-inline-colours]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
